<script setup>
// §8.2 Confirm modal — LModal specialised for a yes/no decision. Cancel is
// always the safe secondary action; pass confirmVariant="destructive" when
// confirming discards or deletes something.
import LModal from './Modal.vue'
import LButton from '../actions/Button.vue'

defineProps({
  title: { type: String, required: true },
  description: { type: String, default: null },
  confirmLabel: { type: String, default: 'Confirm' },
  cancelLabel: { type: String, default: 'Cancel' },
  confirmVariant: { type: String, default: 'primary' },
})
const emit = defineEmits(['confirm', 'cancel'])
const open = defineModel('open', { default: false })

function onCancel() {
  emit('cancel')
  open.value = false
}
function onConfirm() {
  emit('confirm')
  open.value = false
}
</script>

<template>
  <LModal v-model:open="open" :title="title" :description="description">
    <slot />
    <template #footer>
      <LButton variant="secondary" @click="onCancel">{{ cancelLabel }}</LButton>
      <LButton :variant="confirmVariant" @click="onConfirm">{{ confirmLabel }}</LButton>
    </template>
  </LModal>
</template>
